'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoadedVoucher = isLoadedVoucher;
exports.getByUser = getByUser;
exports.getAllCoupon = getAllCoupon;
exports.getAllReward = getAllReward;
exports.getRewardAtSpa = getRewardAtSpa;
exports.getRewardAtHome = getRewardAtHome;
exports.getRewardByCategory = getRewardByCategory;
exports.changeExchangeShop = changeExchangeShop;
exports.resetExchangeShop = resetExchangeShop;
exports.getRewardDetail = getRewardDetail;
exports.getRewardDetailServer = getRewardDetailServer;
exports.getCodeDetail = getCodeDetail;
exports.getAllCampaignByShop = getAllCampaignByShop;
exports.getCouponsByUser = getCouponsByUser;
exports.changeTab = changeTab;
exports.changeHomeTab = changeHomeTab;
exports.setVoucherDetail = setVoucherDetail;
exports.getVoucherById = getVoucherById;
exports.getVoucherServer = getVoucherServer;
exports.getPartnerById = getPartnerById;
exports.setPartnerDetail = setPartnerDetail;
exports.joinCampaign = joinCampaign;
exports.setCode = setCode;
exports.submitCodeEnter = submitCodeEnter;
exports.removeCodeEnter = removeCodeEnter;
exports.setCouponCode = setCouponCode;
exports.getMyReward = getMyReward;
exports.beforeExchangeReward = beforeExchangeReward;
exports.exchangeReward = exchangeReward;
exports.getRewardCampaign = getRewardCampaign;
exports.changeVoucherFilter = changeVoucherFilter;

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _localStorage = require('../../utils/localStorage');

var _ApiServer = require('helpers/ApiServer');

var _ApiClient = require('helpers/ApiClient');

var _Constant = require('helpers/Constant');

var _support = require('helpers/support');

var _CampaignTracking = require('helpers/CampaignTracking');

var _ApiClientv = require('helpers/ApiClientv2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET_BY_USER = 'lookme/voucher/GET_BY_USER';
var GET_BY_USER_FAIL = 'lookme/voucher/GET_BY_USER_FAIL';
var GET_BY_USER_SUCCESS = 'lookme/voucher/GET_BY_USER_SUCCESS';
var SET_VOUCHER_DETAIL = 'lookme/voucher/SET_VOUCHER_DETAIL';
var GET_ALL_COUPON = 'lookme/voucher/GET_ALL_COUPON';
var GET_ALL_COUPON_FAIL = 'lookme/voucher/GET_ALL_COUPON_FAIL';
var GET_ALL_COUPON_SUCCESS = 'lookme/voucher/GET_ALL_COUPON_SUCCESS';
var GET_ALL_MY_VOUCHER = 'lookme/voucher/GET_ALL_MY_VOUCHER';
var GET_ALL_MY_VOUCHER_FAIL = 'lookme/voucher/GET_ALL_MY_VOUCHER_FAIL';
var GET_ALL_MY_VOUCHER_SUCCESS = 'lookme/voucher/GET_ALL_MY_VOUCHER_SUCCESS';
var GET_ALL_CAMPAIGN_BY_SHOP = 'lookme/voucher/GET_ALL_CAMPAIGN_BY_SHOP';
var GET_ALL_CAMPAIGN_BY_SHOP_FAIL = 'lookme/voucher/GET_ALL_CAMPAIGN_BY_SHOP_FAIL';
var GET_ALL_CAMPAIGN_BY_SHOP_SUCCESS = 'lookme/voucher/GET_ALL_CAMPAIGN_BY_SHOP_SUCCESS';
var GET_VOUCHER_BY_ID = 'lookme/voucher/GET_VOUCHER_BY_ID';
var GET_VOUCHER_BY_ID_FAIL = 'lookme/voucher/GET_VOUCHER_BY_ID_FAIL';
var GET_VOUCHER_BY_ID_SUCCESS = 'lookme/voucher/GET_VOUCHER_BY_ID_SUCCESS';
var GET_VOUCHER_SERVER = 'lookme/voucher/GET_VOUCHER_SERVER';
var GET_VOUCHER_SERVER_SUCCESS = 'lookme/voucher/GET_VOUCHER_SERVER_SUCCESS';
var GET_VOUCHER_SERVER_FAIL = 'lookme/voucher/GET_VOUCHER_SERVER_FAIL';
var GET_ALL_REWARD = 'lookme/voucher/GET_ALL_REWARD';
var GET_ALL_REWARD_FAIL = 'lookme/voucher/GET_ALL_REWARD_FAIL';
var GET_ALL_REWARD_SUCCESS = 'lookme/voucher/GET_ALL_REWARD_SUCCESS';
var GET_REWARD_AT_SPA = 'lookme/voucher/GET_REWARD_AT_SPA';
var GET_REWARD_AT_SPA_FAIL = 'lookme/voucher/GET_REWARD_AT_SPA_FAIL';
var GET_REWARD_AT_SPA_SUCCESS = 'lookme/voucher/GET_REWARD_AT_SPA_SUCCESS';
var GET_REWARD_AT_HOME = 'lookme/voucher/GET_REWARD_AT_HOME';
var GET_REWARD_AT_HOME_FAIL = 'lookme/voucher/GET_REWARD_AT_HOME_FAIL';
var GET_REWARD_AT_HOME_SUCCESS = 'lookme/voucher/GET_REWARD_AT_HOME_SUCCESS';

var GET_REWARD_DETAIL = 'lookme/voucher/GET_REWARD_DETAIL';
var GET_REWARD_DETAIL_FAIL = 'lookme/voucher/GET_REWARD_DETAIL_FAIL';
var GET_REWARD_DETAIL_SUCCESS = 'lookme/voucher/GET_REWARD_DETAIL_SUCCESS';

var GET_CODE_DETAIL = 'lookme/voucher/GET_CODE_DETAIL';
var GET_CODE_DETAIL_FAIL = 'lookme/voucher/GET_CODE_DETAIL_FAIL';
var GET_CODE_DETAIL_SUCCESS = 'lookme/voucher/GET_CODE_DETAIL_SUCCESS';

var GET_PARTNER_BY_ID = 'lookme/voucher/GET_PARTNER_BY_ID';
var GET_PARTNER_BY_ID_FAIL = 'lookme/voucher/GET_PARTNER_BY_ID_FAIL';
var GET_PARTNER_BY_ID_SUCCESS = 'lookme/voucher/GET_PARTNER_BY_ID_SUCCESS';

var JOIN_CAMPAIGN = 'lookme/voucher/JOIN_CAMPAIGN';
var JOIN_CAMPAIGN_FAIL = 'lookme/voucher/JOIN_CAMPAIGN_FAIL';
var JOIN_CAMPAIGN_SUCCESS = 'lookme/voucher/JOIN_CAMPAIGN_SUCCESS';
var SET_CODE = 'lookme/voucher/SET_CODE';
var SUBMIT_CODE_ENTERPRISE = 'lookme/voucher/SUBMIT_CODE_ENTERPRISE';
var REMOVE_CODE_ENTERPRISE = 'lookme/voucher/REMOVE_CODE_ENTERPRISE';
var SUBMIT_CODE_ENTERPRISE_SUCCESS = 'lookme/voucher/SUBMIT_CODE_ENTERPRISE_SUCCESS';
var SUBMIT_CODE_ENTERPRISE_FAIL = 'lookme/voucher/SUBMIT_CODE_ENTERPRISE_FAIL';
var GET_COUPON_BY_USER = 'lookme/voucher/GET_COUPON_BY_USER';
var GET_COUPON_BY_USER_SUCCESS = 'lookme/voucher/GET_COUPON_BY_USER_SUCCESS';
var GET_COUPON_BY_USER_FAIL = 'lookme/voucher/GET_COUPON_BY_USER_FAIL';
var SET_COUPON_CODE = 'lookme/voucher/SET_COUPON_CODE';

var GET_MY_REWARD_LIST = 'lookme/voucher/GET_MY_REWARD_LIST';
var GET_MY_REWARD_LIST_SUCCESS = 'lookme/voucher/GET_MY_REWARD_LIST_SUCCESS';
var GET_MY_REWARD_LIST_FAIL = 'lookme/voucher/GET_MY_REWARD_LIST_FAIL';

var GET_REWARD_CAMPAIGN = 'lookme/voucher/GET_REWARD_CAMPAIGN';
var GET_REWARD_CAMPAIGN_SUCCESS = 'lookme/voucher/GET_REWARD_CAMPAIGN_SUCCESS';
var GET_REWARD_CAMPAIGN_FAIL = 'lookme/voucher/GET_REWARD_CAMPAIGN_FAIL';

var GET_REWARD_BY_CATEGORY = 'lookme/voucher/GET_REWARD_BY_CATEGORY';
var GET_REWARD_BY_CATEGORY_SUCCESS = 'lookme/voucher/GET_REWARD_BY_CATEGORY_SUCCESS';
var GET_REWARD_BY_CATEGORY_FAIL = 'lookme/voucher/GET_REWARD_BY_CATEGORY_FAIL';

var SET_PARTNER_DETAIL = 'lookme/voucher/SET_PARTNER_DETAIL';
var CHANGE_TAB = 'lookme/voucher/CHANGE_TAB';
var CHANGE_HOME_TAB_PROMOTION = 'lookme/voucher/CHANGE_HOME_TAB_PROMOTION';

var EXCHANGE_REWARD = 'lookme/voucher/EXCHANGE_REWARD';
var EXCHANGE_REWARD_SUCCESS = 'lookme/voucher/EXCHANGE_REWARD_SUCCESS';
var EXCHANGE_REWARD_FAIL = 'lookme/voucher/EXCHANGE_REWARD_FAIL';

var SET_EXCHANGE_BRANCH = 'lookme/voucher/SET_EXCHANGE_BRANCH';
var SET_EXCHANGE_SHOP = 'lookme/voucher/SET_EXCHANGE_SHOP';

var CHANGE_VOUCHER_FILTER = 'lookme/voucher/CHANGE_VOUCHER_FILTER';

var initialState = {
  data: null,
  loadError: null,
  loaded: false,
  prominentLoaded: false,
  postCount: 0,
  media: [],
  vouchers: [],
  promotionLoaded: false,
  promotionDetailLoaded: false,
  promotions: [],
  promotionDetails: [],
  tabs: 'allReward',
  tabHome: 'spa',
  reward: [],
  reward_detail: null,
  myVoucher: [],
  myVoucherNumber: '',
  joinCampaignData: null,
  joinCampaignError: null,
  toggleJoin: false,
  toggleEnterpriseJoin: false,
  detail: null,
  detailPartner: null,
  code: null,
  codeToSubmit: '',
  promotionsEnterprise: {},
  promotionsEnterpriseError: {},
  joinedError: {},
  couponsJoined: [],
  codesJoined: [],
  voucherFilters: ['Ưu đãi trải nghiệm', 'Ưu đãi 5 sao', 'Ưu đãi của tôi'],
  voucherFilterChosen: '',
  ALL_REWARD_LIST: {
    loading: true,
    data: [],
    fail: false
  },
  REWARD_LIST_NO_STAR: {
    loading: true,
    data: [],
    fail: false
  },
  REWARD_LIST_FIVE_STAR: {
    loading: true,
    data: [],
    fail: false
  },
  MY_REWARD_LIST: {
    loading: true,
    data: [],
    fail: false
  },
  REWARD_LIST_AT_SPA: {
    loading: true,
    data: [],
    fail: false
  },
  REWARD_LIST_AT_HOME: {
    loading: true,
    data: [],
    fail: false
  },
  PACKAGE_DETAIL: {
    loading: true,
    data: null,
    fail: false
  },
  COUPON_CODE_DETAIL: {
    loading: true,
    data: null,
    fail: false
  },
  EXCHANGE_REWARD: {
    loading: true,
    data: null,
    errors: null,
    fail: false
  },
  REWARD_LIST_BY_CATEGORY: {
    loading: true,
    data: [],
    fail: false
  },
  REWARD_CAMPAIGN: {
    loadding: true,
    data: null,
    fail: false
  },
  SUBCAT_FILTER: {
    loading: true,
    data: [],
    fail: false
  },
  SUBCAT_FILTER_ACTIVE: [],
  // @Branch
  exchangeBranch: [],
  exchangeShop: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case GET_BY_USER:
      return (0, _extends3.default)({}, state, {
        gettingByUser: true
      });
    case GET_BY_USER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        vouchers: action.result,
        gettingByUser: false
      });
    case GET_BY_USER_FAIL:
      return (0, _extends3.default)({}, state, {
        gettingByUser: false,
        gettingError: action.error,
        success: true
      });
    case SUBMIT_CODE_ENTERPRISE:
      return (0, _extends3.default)({}, state, {
        promotionsEnterprise: {},
        promotionsEnterpriseError: {}
      });
    case SUBMIT_CODE_ENTERPRISE_SUCCESS:
      (0, _localStorage.localStore)().set('codeEnterprise', action.code);
      return (0, _extends3.default)({}, state, {
        codeToSubmit: action.code,
        promotionsEnterprise: action.result.data
      });
    case SUBMIT_CODE_ENTERPRISE_FAIL:
      (0, _localStorage.localStore)().clear('codeEnterprise');
      return (0, _extends3.default)({}, state, {
        codeToSubmit: '',
        promotionsEnterpriseError: action.error.errors
      });
    case REMOVE_CODE_ENTERPRISE:
      (0, _localStorage.localStore)().clear('codeEnterprise');
      return (0, _extends3.default)({}, state, {
        codeToSubmit: '',
        promotionsEnterprise: {},
        promotionsEnterpriseError: {}
      });
    case GET_ALL_COUPON:
      return (0, _extends3.default)({}, state, {
        gettingAllCoupon: true
      });
    case GET_ALL_COUPON_SUCCESS:
      return (0, _extends3.default)({}, state, {
        promotions: action.result.data,
        gettingAllCoupon: false,
        promotionLoaded: true
      });
    case GET_ALL_COUPON_FAIL:
      return (0, _extends3.default)({}, state, {
        gettingAllCoupon: false,
        gettingAllCouponError: action.error
      });
    case GET_ALL_MY_VOUCHER:
      return (0, _extends3.default)({}, state);
    case GET_ALL_MY_VOUCHER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        myVoucher: action.result.data,
        myVoucherNumber: action.result.number
      });
    case GET_ALL_MY_VOUCHER_FAIL:
      return (0, _extends3.default)({}, state);
    case GET_ALL_CAMPAIGN_BY_SHOP:
      return (0, _extends3.default)({}, state, {
        gettingAllCouponByShop: true
      });
    case GET_ALL_CAMPAIGN_BY_SHOP_SUCCESS:
      return (0, _extends3.default)({}, state, {
        campaigns: action.result.data,
        gettingAllCouponByShop: false,
        promotionDetailLoaded: true
      });
    case GET_ALL_CAMPAIGN_BY_SHOP_FAIL:
      return (0, _extends3.default)({}, state, {
        gettingAllCouponByShop: false,
        gettingAllCouponError: action.error
      });
    case SET_CODE:
      return (0, _extends3.default)({}, state, {
        codeToSubmit: action.code
      });
    case JOIN_CAMPAIGN:
      return (0, _extends3.default)({}, state, {
        joiningCampaign: true,
        joinCampaignData: null,
        joinCampaignError: null
      });
    case JOIN_CAMPAIGN_SUCCESS:
      var typeVoucher = action.typeVoucher;

      var _state = {};
      if (typeVoucher === 'general') {
        var detail = (0, _extends3.default)({}, state.detail, {
          coupon: action.result.campaign,
          campaign: action.result.campaign
        });
        _state = {
          detail: detail
        };
      } else if (typeVoucher === 'partner') {
        _state = {
          promotionsEnterprise: action.result.data
        };
      }
      _reactGa2.default.event({
        category: 'Promotion',
        action: 'Join success',
        label: '' + state.code.code
      });
      return (0, _extends3.default)({}, state, _state, {
        toggleJoin: !state.toggleJoin,
        joinCampaignData: action.result,
        joiningCampaign: false
      });
    case JOIN_CAMPAIGN_FAIL:
      _reactGa2.default.event({
        category: 'Promotion',
        action: 'Join failure',
        label: '' + state.code.code
      });
      return (0, _extends3.default)({}, state, {
        toggleJoin: !state.toggleJoin,
        joiningCampaign: false,
        joinCampaignError: action.error.errors
      });
    case GET_VOUCHER_BY_ID:
      return (0, _extends3.default)({}, state);
    case GET_VOUCHER_BY_ID_SUCCESS:
      return (0, _extends3.default)({}, state, {
        detail: action.result.data
      });
    case GET_VOUCHER_BY_ID_FAIL:
      return (0, _extends3.default)({}, state, {
        detail: null
      });
    case GET_ALL_REWARD:
      {
        return (0, _extends3.default)({}, state, {
          All_REWARD_LIST: {
            loading: true,
            data: [],
            fail: false
          }
        });
      }
    case GET_ALL_REWARD_SUCCESS:
      {
        var noStarArray = [];
        var fiveStarArray = [];
        if (action.result && action.result.data && action.result.data.length > 0) {
          action.result.data.map(function (i) {
            if (i.star === 5) {
              var shop = i.shop,
                  serviceRewrite = i.serviceRewrite;

              if (shop && serviceRewrite && shop.mainCat !== '05' && serviceRewrite.category !== '05') {
                fiveStarArray.push(i);
              }
            } else {
              var _shop = i.shop,
                  _serviceRewrite = i.serviceRewrite;

              if (_shop && _serviceRewrite && _shop.mainCat !== '05' && _serviceRewrite.category !== '05') {
                noStarArray.push(i);
              }
            }
          });
        }
        var subCatFilter = _support.Helper.parseSubcatFromVoucher(action.result.data);
        console.log({ subCatFilter: subCatFilter });
        return (0, _extends3.default)({}, state, {
          SUBCAT_FILTER: {
            loading: false,
            fail: false,
            data: subCatFilter
          },
          ALL_REWARD_LIST: (0, _extends3.default)({
            loading: false,
            fail: false
          }, action.result),
          REWARD_LIST_NO_STAR: {
            loading: false,
            fail: false,
            data: noStarArray
          },
          REWARD_LIST_FIVE_STAR: {
            loading: false,
            fail: false,
            data: fiveStarArray
          }
        });
      }
    case GET_ALL_REWARD_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          ALL_REWARD_LIST: (0, _extends3.default)({
            loading: false,
            data: [],
            fail: true
          }, action.error)
        });
      }
    case GET_REWARD_AT_SPA:
      {
        return (0, _extends3.default)({}, state, {
          REWARD_LIST_AT_SPA: {
            loading: true,
            data: [],
            fail: false
          }
        });
      }
    case GET_REWARD_AT_SPA_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          REWARD_LIST_AT_SPA: (0, _extends3.default)({
            loading: false,
            fail: false
          }, action.result)
        });
      }
    case GET_REWARD_AT_SPA_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          REWARD_LIST_AT_SPA: (0, _extends3.default)({
            loading: false,
            data: [],
            fail: true
          }, action.error)
        });
      }
    case GET_REWARD_AT_HOME:
      {
        return (0, _extends3.default)({}, state, {
          REWARD_LIST_AT_HOME: {
            loading: true,
            data: [],
            fail: false
          }
        });
      }
    case GET_REWARD_AT_HOME_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          REWARD_LIST_AT_HOME: (0, _extends3.default)({
            loading: false,
            fail: false
          }, action.result)
        });
      }
    case GET_REWARD_AT_HOME_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          REWARD_LIST_AT_HOME: (0, _extends3.default)({
            loading: false,
            data: [],
            fail: true
          }, action.error)
        });
      }
    case GET_REWARD_BY_CATEGORY:
      {
        return (0, _extends3.default)({}, state, {
          REWARD_LIST_BY_CATEGORY: {
            loading: true,
            data: [],
            fail: false
          }
        });
      }
    case GET_REWARD_BY_CATEGORY_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          REWARD_LIST_BY_CATEGORY: (0, _extends3.default)({
            loading: false,
            fail: false
          }, action.result)
        });
      }
    case GET_REWARD_BY_CATEGORY_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          REWARD_LIST_BY_CATEGORY: (0, _extends3.default)({
            loading: false,
            data: [],
            fail: true
          }, action.error)
        });
      }
    case GET_REWARD_DETAIL:
      return (0, _extends3.default)({}, state, {
        PACKAGE_DETAIL: {
          loading: true,
          data: null,
          fail: false
        }
      });
    case GET_REWARD_DETAIL_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          PACKAGE_DETAIL: (0, _extends3.default)({
            loading: false,
            fail: false
          }, action.result)
        });
      }
    case GET_REWARD_DETAIL_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          PACKAGE_DETAIL: (0, _extends3.default)({
            loading: false,
            data: null,
            fail: true
          }, action.error)
        });
      }
    case GET_CODE_DETAIL:
      return (0, _extends3.default)({}, state, {
        COUPON_CODE_DETAIL: {
          loading: true,
          data: null,
          fail: false
        }
      });
    case GET_CODE_DETAIL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        COUPON_CODE_DETAIL: (0, _extends3.default)({
          loading: false,
          fail: false
        }, action.result)
      });
    case GET_CODE_DETAIL_FAIL:
      return (0, _extends3.default)({}, state, {
        COUPON_CODE_DETAIL: (0, _extends3.default)({
          loading: false,
          data: null,
          fail: true
        }, action.error)
      });
    case GET_PARTNER_BY_ID:
      return (0, _extends3.default)({}, state);
    case GET_PARTNER_BY_ID_SUCCESS:
      return (0, _extends3.default)({}, state, {
        detailPartner: action.result.data
      });
    case GET_PARTNER_BY_ID_FAIL:
      return (0, _extends3.default)({}, state, {
        detailPartner: null
      });
    case CHANGE_TAB:
      return (0, _extends3.default)({}, state, {
        tabs: action.tabs
      });
    case CHANGE_HOME_TAB_PROMOTION:
      return (0, _extends3.default)({}, state, {
        tabHome: action.tabHome
      });
    case SET_PARTNER_DETAIL:
      return (0, _extends3.default)({}, state, {
        detailPartner: action.detail
      });
    case SET_VOUCHER_DETAIL:
      return (0, _extends3.default)({}, state, {
        detail: action.voucher
      });
    case GET_COUPON_BY_USER:
      return (0, _extends3.default)({}, state, {
        couponsJoined: [],
        codesJoined: []
      });
    case GET_COUPON_BY_USER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        couponsJoined: action.result.coupons,
        codesJoined: action.result.codes
      });
    case GET_COUPON_BY_USER_FAIL:
      return (0, _extends3.default)({}, state, {
        joinedError: action.error.errors
      });
    case SET_COUPON_CODE:
      return (0, _extends3.default)({}, state, {
        code: action.code
      });
    case GET_MY_REWARD_LIST:
      {
        return (0, _extends3.default)({}, state, {
          MY_REWARD_LIST: {
            loading: true,
            data: [],
            fail: false
          }
        });
      }
    case GET_MY_REWARD_LIST_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          MY_REWARD_LIST: (0, _extends3.default)({
            loading: false,
            fail: false
          }, action.result)
        });
      }
    case GET_MY_REWARD_LIST_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          MY_REWARD_LIST: (0, _extends3.default)({
            loading: false,
            data: [],
            fail: true
          }, action.error)
        });
      }
    case EXCHANGE_REWARD:
      {
        return (0, _extends3.default)({}, state, {
          EXCHANGE_REWARD: {
            loading: true,
            data: null,
            errors: null,
            fail: false
          }
        });
      }
    case EXCHANGE_REWARD_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          EXCHANGE_REWARD: (0, _extends3.default)({
            loading: false,
            fail: false
          }, action.result)
        });
      }
    case EXCHANGE_REWARD_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          EXCHANGE_REWARD: (0, _extends3.default)({
            loading: false,
            fail: true
          }, action.error)
        });
      }
    case GET_REWARD_CAMPAIGN:
      {
        return (0, _extends3.default)({}, state, {
          REWARD_CAMPAIGN: {
            loading: true,
            data: null,
            fail: false
          }
        });
      }
    case GET_REWARD_CAMPAIGN_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          REWARD_CAMPAIGN: (0, _extends3.default)({
            loading: false,
            fail: false
          }, action.result)
        });
      }
    case GET_REWARD_CAMPAIGN_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          REWARD_CAMPAIGN: (0, _extends3.default)({
            loading: true,
            data: null
          }, action.error)
        });
      }
    case SET_EXCHANGE_BRANCH:
      {
        return (0, _extends3.default)({}, state, {
          exchangeBranch: action.result.data
        });
      }
    case SET_EXCHANGE_SHOP:
      {
        return (0, _extends3.default)({}, state, {
          exchangeShop: action.result.data
        });
      }
    case CHANGE_VOUCHER_FILTER:
      {
        return (0, _extends3.default)({}, state, {
          voucherFilterChosen: action.voucherType
        });
      }
    default:
      return state;
  }
}
function parseUrl(query) {
  if (query === undefined) {
    return '';
  }
  var array = [];
  for (var key in query) {
    if (query.hasOwnProperty(key) && query[key]) {
      array.push(key + '=' + query[key]);
    }
  }
  return array.join('&');
}
function isLoadedVoucher(globalState) {
  return globalState.detail;
}
function getByUser() {
  return {
    types: [GET_BY_USER, GET_BY_USER_SUCCESS, GET_BY_USER_FAIL],
    promise: function promise(client) {
      return client.get('/coupon/get-by-user');
    }
  };
}
function getAllCoupon(filter) {
  var query = {
    sort: 'order',
    sortTo: true
  };
  if (filter) {
    query = (0, _extends3.default)({}, query, filter);
  }
  var url = parseUrl(query);
  return {
    types: [GET_ALL_COUPON, GET_ALL_COUPON_SUCCESS, GET_ALL_COUPON_FAIL],
    promise: function promise(client) {
      return client.get('/coupon/loadAll?' + url);
    }
  };
}
// export function getAllCouponByShop(shopId) {
//   return {
//     types: [GET_ALL_COUPON_BY_SHOP, GET_ALL_COUPON_BY_SHOP_SUCCESS, GET_ALL_COUPON_BY_SHOP_FAIL],
//     promise: (client) => client.get(`/coupon/loadAllByShop/${shopId}`)
//   };
// }
function getAllReward(query) {
  var url = parseUrl(query);
  return {
    types: [GET_ALL_REWARD, GET_ALL_REWARD_SUCCESS, GET_ALL_REWARD_FAIL],
    promise: function promise() {
      return _ApiClientv.elasticSearch.get('/coupon/allVoucher?' + url);
    }
  };
}
function getRewardAtSpa() {
  var queryAtSpa = {
    pageSize: 1000,
    atHome: false
  };
  var url = parseUrl(queryAtSpa);
  return {
    types: [GET_REWARD_AT_SPA, GET_REWARD_AT_SPA_SUCCESS, GET_REWARD_AT_SPA_FAIL],
    promise: function promise(client) {
      return client.get('/coupon/allVoucher?' + url);
    }
  };
}
function getRewardAtHome() {
  var queryAtHome = {
    pageSize: 1000,
    atHome: true
  };
  var url = parseUrl(queryAtHome);
  return {
    types: [GET_REWARD_AT_HOME, GET_REWARD_AT_HOME_SUCCESS, GET_REWARD_AT_HOME_FAIL],
    promise: function promise(client) {
      return client.get('/coupon/allVoucher?' + url);
    }
  };
}
function getRewardByCategory(query) {
  var url = parseUrl(query);
  return {
    types: [GET_REWARD_BY_CATEGORY, GET_REWARD_BY_CATEGORY_SUCCESS, GET_REWARD_BY_CATEGORY_FAIL],
    promise: function promise(client) {
      return client.get('/coupon/allVoucher?' + url);
    }
  };
}
function changeExchangeShop(shop) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (shop) dispatch({ type: SET_EXCHANGE_SHOP, result: { data: shop } });
              if (shop && shop.pack) {
                dispatch({
                  type: GET_REWARD_DETAIL_SUCCESS,
                  result: { data: shop.pack }
                });
              }

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x3) {
      return _ref.apply(this, arguments);
    };
  }();
}
function resetExchangeShop() {
  return function (dispatch) {
    dispatch({ type: SET_EXCHANGE_SHOP, result: { data: null } });
  };
}
// export function getRewardDetail(handle) {
//   return {
//     types: [
//       GET_REWARD_DETAIL,
//       GET_REWARD_DETAIL_SUCCESS,
//       GET_REWARD_DETAIL_FAIL,
//     ],
//     promise: client => client.get(`/coupon/detail/${handle}`),
//   };
// }
function getRewardDetail(handle) {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch) {
      var res, exchangeBranch;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch({ type: GET_REWARD_DETAIL });
              _context2.prev = 1;
              _context2.next = 4;
              return _ApiClient.client.get('/coupon/detail/' + handle);

            case 4:
              res = _context2.sent;
              exchangeBranch = _support.Helper.parseBranchByPacks(res.data.packs);

              if (exchangeBranch && exchangeBranch.length) {
                dispatch({
                  type: SET_EXCHANGE_BRANCH,
                  result: { data: exchangeBranch }
                });
              }
              dispatch({ type: GET_REWARD_DETAIL_SUCCESS, result: { data: res.data } });
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](1);

              dispatch({ type: GET_REWARD_DETAIL_FAIL, error: _context2.t0 });

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[1, 10]]);
    }));

    return function (_x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}
function getRewardDetailServer(handle) {
  return {
    types: [GET_REWARD_DETAIL, GET_REWARD_DETAIL_SUCCESS, GET_REWARD_DETAIL_FAIL],
    promise: function promise() {
      return _ApiServer.server.get('/coupon/detail/' + handle);
    }
  };
}
function getCodeDetail(code) {
  return {
    types: [GET_CODE_DETAIL, GET_CODE_DETAIL_SUCCESS, GET_CODE_DETAIL_FAIL],
    promise: function promise(client) {
      return client.get('/coupon/detailCode/' + code);
    }
  };
}
function getAllCampaignByShop(shopId) {
  return {
    types: [GET_ALL_CAMPAIGN_BY_SHOP, GET_ALL_CAMPAIGN_BY_SHOP_SUCCESS, GET_ALL_CAMPAIGN_BY_SHOP_FAIL],
    promise: function promise(client) {
      return client.get('/coupon/loadAllByShop/' + shopId);
    }
  };
}
function getCouponsByUser() {
  // TODO: có 2 loại coupon cần lấy (chung và cả đối tác) hàm này support hết.
  return {
    types: [GET_COUPON_BY_USER, GET_COUPON_BY_USER_SUCCESS, GET_COUPON_BY_USER_FAIL],
    promise: function promise(client) {
      return client.get('coupon/loadCouponsByUser');
    }
  };
}
function changeTab(tab) {
  return {
    type: CHANGE_TAB,
    tabs: tab
  };
}
function changeHomeTab(tab) {
  return {
    type: CHANGE_HOME_TAB_PROMOTION,
    tabHome: tab
  };
}
function setVoucherDetail(item, isJoin) {
  return {
    type: SET_VOUCHER_DETAIL,
    voucher: item,
    isJoin: isJoin
  };
}
function getVoucherById(voucherId) {
  return {
    types: [GET_VOUCHER_BY_ID, GET_VOUCHER_BY_ID_SUCCESS, GET_VOUCHER_BY_ID_FAIL],
    promise: function promise(client) {
      return client.get('/coupon/loadOnePackage/' + voucherId);
    }
  };
}
function getVoucherServer(voucherHandle) {
  return {
    types: [GET_VOUCHER_SERVER, GET_VOUCHER_SERVER_SUCCESS, GET_VOUCHER_SERVER_FAIL],
    promise: function promise() {
      return _ApiServer.server.get('/coupon/loadOnePackage/' + voucherHandle);
    }
  };
}
function getPartnerById(packId) {
  return {
    types: [GET_PARTNER_BY_ID, GET_PARTNER_BY_ID_SUCCESS, GET_PARTNER_BY_ID_FAIL],
    promise: function promise(client) {
      return client.get('/coupon/loadOnePackage/' + packId);
    }
  };
}
function setPartnerDetail(detail) {
  return {
    type: SET_PARTNER_DETAIL,
    detail: detail
  };
}
function joinCampaign(data) {
  var token = (0, _localStorage.localStore)().get('token');
  var _data = (0, _extends3.default)({}, data, { token: token });
  return {
    types: [JOIN_CAMPAIGN, JOIN_CAMPAIGN_SUCCESS, JOIN_CAMPAIGN_FAIL],
    promise: function promise(client) {
      return client.post('/coupon/joinCode', {
        data: _data
      });
    },
    typeVoucher: _data.typeVoucher
  };
}

function setCode(code) {
  return {
    type: SET_CODE,
    code: code
  };
}

function submitCodeEnter(code) {
  var _code = code || (0, _localStorage.localStore)().get('codeEnterprise');
  if (!_code) return false;
  var token = (0, _localStorage.localStore)().get('token');
  var _data = {
    code: _code,
    token: token
  };
  return {
    types: [SUBMIT_CODE_ENTERPRISE, SUBMIT_CODE_ENTERPRISE_SUCCESS, SUBMIT_CODE_ENTERPRISE_FAIL],
    promise: function promise(client) {
      return client.post('/coupon/submitCodeNew', {
        data: _data
      });
    },
    code: _code
  };
}

function removeCodeEnter() {
  return {
    type: REMOVE_CODE_ENTERPRISE
  };
}

function setCouponCode(code) {
  return {
    type: SET_COUPON_CODE,
    code: code
  };
}

function getMyReward() {
  var token = (0, _localStorage.localStore)().get('token');
  if (!token) {
    return {
      type: GET_ALL_MY_VOUCHER_FAIL
    };
  }

  return {
    types: [GET_MY_REWARD_LIST, GET_MY_REWARD_LIST_SUCCESS, GET_MY_REWARD_LIST_FAIL],
    promise: function promise(client) {
      return client.get('/coupon/myVoucher');
    }
  };
}
function beforeExchangeReward(item) {
  return function (dispatch, getState) {
    var _getState = getState(),
        myRewards = _getState.voucher.MY_REWARD_LIST.data;

    if (item.notSupportOn && item.notSupportOn.indexOf('web') !== -1) {
      return {
        type: 'REWARD_FOR_APP',
        content: (0, _extends3.default)({}, _Constant.MODAL_CUSTOM.REWARD_FOR_APP)
      };
    }
    var exu = item.exu,
        shop = item.shop,
        serviceRewrite = item.serviceRewrite;

    if (serviceRewrite && serviceRewrite.category === '05') {
      return {
        type: 'CATEGORY_SERVICE_FOR_APP',
        content: (0, _extends3.default)({}, _Constant.MODAL_CUSTOM.CATEGORY_SERVICE_FOR_APP)
      };
    }
    if (item.numPacks > 1) {
      return {
        success: false,
        type: 'REQUIRE_EXCHANGE_SHOP',
        content: (0, _extends3.default)({}, _Constant.MODAL_CUSTOM.REQUIRE_EXCHANGE_SHOP)
      };
    }
    var content = {};
    var rewardExisted = myRewards.filter(function (v) {
      return v.packageService._id === item.packId;
    });
    var accessToken = (0, _localStorage.localStore)().get('token');
    if (rewardExisted.length) {
      content = (0, _extends3.default)({}, _Constant.MODAL_CUSTOM.REWARD_EXISTED);
      return {
        content: content,
        data: (0, _extends3.default)({}, item, { couponCode: rewardExisted[0] }),
        type: 'REWARD_EXISTED'
      };
    }
    if (!exu && shop.isBooking || accessToken) {
      content = (0, _extends3.default)({}, _Constant.MODAL_CUSTOM.CONFIRM_EXCHANGE_REWARD);
      return { content: content, data: item, type: 'CONFIRM_EXCHANGE_REWARD' };
    }
    content = (0, _extends3.default)({}, _Constant.MODAL_CUSTOM.REQUIRE_LOGIN);
    return { content: content, data: item, type: 'REQUIRE_LOGIN' };
  };
}

function exchangeReward(item) {
  var _this3 = this;

  // item: _item () , image newPrice oldPrice shopName address exu allowExchange handle packId shop service
  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch) {
      var accessToken, body, content, res;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              accessToken = (0, _localStorage.localStore)().get('token');
              body = {
                packageServiceId: item.packId,
                trackingParams: (0, _CampaignTracking.getTrackingParams)()
              };

              dispatch({ type: EXCHANGE_REWARD });
              content = {};
              _context3.prev = 4;
              _context3.next = 7;
              return _ApiClient.client.post('/coupon/redeem', {
                jsonData: body
              });

            case 7:
              res = _context3.sent;

              dispatch({ type: EXCHANGE_REWARD_SUCCESS, result: res });

              if (!accessToken) {
                _context3.next = 13;
                break;
              }

              content = (0, _extends3.default)({}, _Constant.MODAL_CUSTOM.EXCHANGE_REWARD_SUCCESS);
              content.message = [{ text: res.message }].concat((0, _toConsumableArray3.default)(content.message));
              return _context3.abrupt('return', {
                success: true,
                type: 'EXCHANGE_REWARD_SUCCESS',
                content: content,
                data: (0, _extends3.default)({}, item, { code: res.code, couponCode: res.couponCode })
              });

            case 13:
              return _context3.abrupt('return', {
                success: true,
                type: 'TO_BOOKING',
                data: (0, _extends3.default)({}, item, { code: res.code, couponCode: res.couponCode })
              });

            case 16:
              _context3.prev = 16;
              _context3.t0 = _context3['catch'](4);

              dispatch({ type: EXCHANGE_REWARD_FAIL, error: _context3.t0 });
              content = (0, _extends3.default)({}, _Constant.MODAL_CUSTOM.EXCHANGE_REWARD_FAIL);
              content.message = [{
                text: _context3.t0.errors.message || 'Rất xin lỗi bạn vì sự bất tiện này, vui lòng liên hệ lookme để được hỗ trợ.'
              }].concat((0, _toConsumableArray3.default)(content.message));
              return _context3.abrupt('return', {
                success: false,
                type: 'EXCHANGE_REWARD_FAIL',
                content: content,
                data: item
              });

            case 22:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[4, 16]]);
    }));

    return function (_x5) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function getRewardCampaign(handle) {
  var district = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  // /coupon/loadForInternal/:handle
  return {
    types: [GET_REWARD_CAMPAIGN, GET_REWARD_CAMPAIGN_SUCCESS, GET_REWARD_CAMPAIGN_FAIL],
    promise: function promise(client) {
      return client.get('/coupon/loadForInternal/' + handle + '?district=' + district);
    }
  };
}

function changeVoucherFilter(voucherType) {
  return {
    type: CHANGE_VOUCHER_FILTER,
    voucherType: voucherType
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/voucher.js
// module id = 28
// module chunks = 0